import { AdminScreen } from './admin.models';
import { action, Action } from 'easy-peasy';

export interface IAdminModel {
	currentScreen: AdminScreen;
	messageTitle: string;
	messageContent: string;
}

export interface IAdminStore extends IAdminModel {
	setScreen: Action<IAdminStore, AdminScreen>;
	setMessage: Action<IAdminStore, { title: string; content: string }>;
}

const adminStore: IAdminStore = {
	currentScreen: AdminScreen.Setup,
	setScreen: action((state, payload) => ({
		...state,
		currentScreen: payload,
	})),
	messageTitle: '',
	messageContent: '',
	setMessage: action((state, { title, content }) => ({
		...state,
		messageTitle: title,
		messageContent: content,
	})),
};

export default adminStore;
